import labels from "app/labels";
import * as ko from "knockout";
import { system, LookupStorage } from "portalframework";
export class BaseService {
  protected controllerName: string;
  protected baseApiUrl: KnockoutComputed<string>;

  constructor(controllerName: string) {
    this.controllerName = controllerName;
    this.baseApiUrl = ko.computed(() => {
      return `${system.apiURL()}api/${this.controllerName}`;
    });
  }

  protected setLookups = (lookupsToFetch: string[], results: any) => {
    if (results) {
      lookupsToFetch.forEach((lookupName) => {
        let list = results[lookupName];
        if (list) {
          LookupStorage.lookupStorage.add(new LookupStorage.Lookup(lookupName, list));
        }
      });
    }
  };
}
